import { FunctionComponent, MouseEvent } from 'react';
import { Badge } from 'dibs-elements/exports/Badge';
import { SeoLink } from 'dibs-elements/exports/SeoLink';
import styles from './SharedRelatedItems.scss';
import classnames from 'classnames';

import { BuySharedRelatedPages_buyPage$data } from '../../buy/BuySharedRelatedPages/__generated__/BuySharedRelatedPages_buyPage.graphql';
import { SbSharedRelatedSearches_itemSearch$data } from '../../finding/SbSharedRelatedSearches/__generated__/SbSharedRelatedSearches_itemSearch.graphql';

type Props = {
    relatedItems:
        | BuySharedRelatedPages_buyPage$data['relatedBuyPages']
        | SbSharedRelatedSearches_itemSearch$data['relatedSearches'];
    onClick?: (index: number, event: MouseEvent) => void;
    isFullWidth?: boolean | null;
    isLinkable?: boolean;
    dataTn?: string;
    wrapperClassName?: string | null;
};

export const SharedRelatedItems: FunctionComponent<Props> = ({
    relatedItems,
    onClick = () => {},
    isFullWidth,
    isLinkable,
    dataTn,
    wrapperClassName,
}) => {
    const wrapperClasses = classnames(styles.wrapper, wrapperClassName, {
        [styles.fullWidthWrapper]: isFullWidth,
    });
    const innerWrapperClasses = classnames(styles.innerWrapper, {
        [styles.fullWidthInnerWrapper]: isFullWidth,
    });

    if (!relatedItems) {
        return null;
    }

    return (
        <div className={wrapperClasses}>
            <div className={innerWrapperClasses}>
                {relatedItems.map((item, index) => {
                    const { url, anchorText } = item || {};
                    if (url && anchorText) {
                        return (
                            <SeoLink
                                key={url}
                                linkData={{ path: url, isLinkable }}
                                onClick={event => onClick(index, event)}
                                dataTn={dataTn}
                                className={`${styles.link} ${styles.specify}`}
                            >
                                <Badge type="pill" size="medium-regular" interactive>
                                    {anchorText}
                                </Badge>
                            </SeoLink>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
};

SharedRelatedItems.defaultProps = {
    isLinkable: true,
};
